/** A workspace the person belongs to in Workeffy, which is also a Lyearn sub-workspace. */
export type SwitcherWorkspace = {
  /** Short code: the Lyearn sub-workspace id. */
  id: string;
  /** Full Workeffy id, what `switchWorkspace` takes. */
  workeffyId: string;
  name: string;
};

/** Workeffy expects the full Person id, same shape as `composePersonKnowledgeOwnerId`. */
export const composePersonId = (workspaceId: string, userId: string) =>
  `${workspaceId}::Person::${userId}`;
